// extracted by mini-css-extract-plugin
export default {"footer":"Contacts_footer__ZRp4R","icon":"Contacts_icon__ahbUS","link":"Contacts_link__OXAna"};